import React from 'react'

import { FOX1_THEME, FOX_THEME, WSJ_THEME } from 'common/constants'
import FoxAboveCta from 'components/rich-cta/copy-only/components/FoxAboveCta'
import AdvertisementText from 'components/advertisement-text'

const interactiveConfig = {
  [WSJ_THEME]: {
    AboveCta: () => <AdvertisementText placement="right" />,
  },
  [FOX_THEME]: {
    AboveCta: FoxAboveCta,
  },
  [FOX1_THEME]: {
    AboveCta: FoxAboveCta,
  },
  default: {
    AboveCta: () => {},
  },
}

export default interactiveConfig
